import { useState } from "react";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import Cookies from "js-cookie";
import "../../styles/Login.css";

export default function Register() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPw, setShowPw] = useState(false);

  const [msg, setMsg] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");
    setSuccess("");

    if (!firstName.trim() || !lastName.trim() || !email.trim() || !password) {
      setMsg("Please fill in First name, Last name, Email, and Password.");
      return;
    }
    if (password.length < 8) {
      setMsg("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setMsg("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);
      const full_name = `${firstName} ${lastName}`.trim();
      const params = new URLSearchParams(window.location.search);
      const redirect = params.get("redirect");
      const pendingJobId =
        Cookies.get("pendingJobId") ||
        (redirect?.startsWith("/apply/")
          ? redirect.split("/apply/")[1]?.split("?")[0]
          : "");

      await axios.post(`${BASE_URL}/api/auth/register`, {
        email,
        mobile,
        password,
        first_name: firstName.trim(),
        last_name: lastName.trim(),
        full_name,
        pending_job_id: pendingJobId ? Number(pendingJobId) : null,
      });

      setSuccess("✔️ Verification email sent. Please check your inbox.");
    } catch (err) {
      setMsg(err.response?.data?.message || err.message || "Register failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg">
      <div className="login-card">
        <h3 className="auth-title">Create account</h3>

        <form onSubmit={submit} className="auth-form" noValidate>
          <label>First name</label>
          <input
            className="form-control"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Jane"
            required
            autoComplete="given-name"
          />

          <label>Last name</label>
          <input
            className="form-control"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Doe"
            required
            autoComplete="family-name"
          />

          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="jane@example.com"
            required
            autoComplete="email"
          />

          <label>Mobile</label>
          <input
            type="mobile"
            className="form-control"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="1234567890"
            required
            pattern="\d{10}"
            title="Mobile number must be exactly 10 digits"
            autoComplete="tel"
          />

          <label>Password</label>
          <div className="input-group">
            <input
              type={showPw ? "text" : "password"}
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
              minLength={8}
              placeholder="At least 8 characters"
            />
            <button
              type="button"
              className="input-group-text"
              onClick={() => setShowPw((s) => !s)}
              aria-label={showPw ? "Hide password" : "Show password"}
            >
              {showPw ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <label>Confirm Password</label>
          <input
            type={showPw ? "text" : "password"}
            className="form-control"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            autoComplete="new-password"
            minLength={8}
            placeholder="Re-enter password"
          />

          <button
            type="submit"
            className="btn btn-primary auth-submit"
            disabled={loading}
            style={{ marginTop: 10 }}
          >
            {loading ? "Creating..." : "Create"}
          </button>
        </form>

        {msg && <p className="auth-error">{msg}</p>}

        {success && (
          <div className="success" style={{ marginTop: 12 }}>
            <p>{success}</p>
          </div>
        )}
        <div className="auth-links">
          Already have an account?{" "}
          <Link to="/login" className="link-cta">
            Login
          </Link>
        </div>
      </div>
    </div>
  );
}
